<template>
  <section id="about" class="section section-observed intro-grid">
    <div class="notice-board">
      <div class="notice-board__heading">
        <h3>通知要闻</h3>
        <button type="button" class="text-link" @click="front.goPath('/news-publish')">
          查看全部通知要闻
        </button>
      </div>

      <div class="notice-board__columns">
        <article
          v-for="board in noticeBoards"
          :key="board.code"
          class="notice-board__block"
        >
          <header class="notice-board__block-head">
            <h4>{{ board.label }}</h4>
            <button
              type="button"
              class="text-link"
              @click="front.goPath(`/news-publish?board=${board.code}`)"
            >
              更多 &gt;&gt;
            </button>
          </header>
          <ul class="notice-board__list">
            <li v-for="item in itemsByBoard[board.code]" :key="itemKey(item)">
              <button type="button" class="notice-board__item" @click="front.openContentDetail(item)">
                <span class="notice-board__type">{{ board.label }}</span>
                <span class="notice-board__title">{{ item.title }}</span>
                <time v-if="item.date">{{ item.date }}</time>
              </button>
            </li>
            <li v-if="!itemsByBoard[board.code].length" class="notice-board__empty muted-copy">暂无内容</li>
          </ul>
        </article>
      </div>
    </div>

    <div class="featured-notice">
      <template v-if="featuredList.length">
        <button
          type="button"
          class="featured-notice__card"
          :class="{ 'is-fallback': !activeCoverUrl }"
          @click="front.openContentDetail(activeFeature)"
        >
          <div class="featured-notice__media" aria-hidden="true">
            <img v-if="activeCoverUrl" :src="activeCoverUrl" :alt="activeFeature.title || ''">
          </div>
          <div class="featured-notice__caption">
            <span v-if="activeFeature.type" class="featured-notice__tag">{{ activeFeature.type }}</span>
            <strong>{{ activeFeature.title }}</strong>
            <time v-if="activeFeature.date">{{ activeFeature.date }}</time>
            <p v-if="!activeCoverUrl && activeFeature.summary" class="featured-notice__summary">
              {{ activeFeature.summary }}
            </p>
          </div>
        </button>
        <div v-if="featuredList.length > 1" class="featured-notice__nav" aria-label="图文精选切换">
          <button
            v-for="(item, index) in featuredList"
            :key="item.entryId || item.contentId || index"
            type="button"
            :class="{ active: activeIndex === index }"
            :aria-label="`第 ${index + 1} 条`"
            @click.stop="activeIndex = index"
          />
        </div>
      </template>
      <div v-else class="featured-notice__empty">
        <p class="section-kicker">图文精选</p>
        <h2>暂无首页精选内容</h2>
        <p>请在管理后台「通知要闻」中维护封面图，并勾选「在首页展示」。</p>
      </div>
    </div>
  </section>
</template>

<script>
import { listPublicCmsEntries, unwrapPublicPage } from '@/api/paleo'
import { NOTICE_NEWS_BOARDS } from '@/data/navMenus'
import { preferHomepageEntries } from '@/utils/cmsExtra'

const LIST_SIZE = 5

export default {
  name: 'IntroNotices',
  inject: ['front'],
  data() {
    return {
      activeIndex: 0,
      featureTimer: null,
      noticeBoards: NOTICE_NEWS_BOARDS,
      itemsByBoard: {
        meeting_notice: [],
        important_news: []
      }
    }
  },
  computed: {
    featuredList() {
      return this.front.homepageFeaturedEntries || []
    },
    activeFeature() {
      return this.featuredList[this.activeIndex] || this.featuredList[0] || null
    },
    activeCoverUrl() {
      if (!this.activeFeature) return ''
      const url = this.activeFeature.coverImageUrl || this.activeFeature.coverUrl
      return url ? this.front.resolvePublicDisplayUrl(url) : ''
    }
  },
  watch: {
    featuredList: {
      immediate: true,
      handler() {
        this.activeIndex = 0
        this.restartFeatureTimer()
      }
    }
  },
  created() {
    this.loadNoticeBoards()
  },
  beforeDestroy() {
    this.clearFeatureTimer()
  },
  methods: {
    itemKey(item) {
      return item.entryId || item.contentId || item.title
    },
    async loadNoticeBoards() {
      try {
        const results = await Promise.all(
          this.noticeBoards.map(board =>
            listPublicCmsEntries({
              moduleCode: 'publish',
              columnCode: board.code,
              pageNum: 1,
              pageSize: LIST_SIZE
            }).catch(() => ({ rows: [], total: 0 }))
          )
        )
        const next = { ...this.itemsByBoard }
        this.noticeBoards.forEach((board, index) => {
          const rows = unwrapPublicPage(results[index]).rows || []
          next[board.code] = preferHomepageEntries(rows.map(row => this.front.mapCmsEntry(row)))
        })
        this.itemsByBoard = next
      } catch (error) {
        // 首页区块失败静默，不影响首屏其它模块
      }
    },
    clearFeatureTimer() {
      if (this.featureTimer) {
        clearInterval(this.featureTimer)
        this.featureTimer = null
      }
    },
    restartFeatureTimer() {
      this.clearFeatureTimer()
      if (this.featuredList.length <= 1) return
      this.featureTimer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.featuredList.length
      }, 5000)
    }
  }
}
</script>
